import Link from 'next/link';
import { IBreadcrumbStep } from '@typescript/index';
import styles from '@components/Breadcrumbs/Breadcrumbs.style';
type DropdownProps = {
  activeDropdown: IBreadcrumbStep | null;
  leftPosition: number;
  onMouseLeave: (event: React.MouseEvent) => void;
  dropdownRef: React.RefObject<HTMLDivElement | null>;
};
const BreadcrumbDropdown = ({
  activeDropdown,
  leftPosition,
  onMouseLeave,
  dropdownRef
}: DropdownProps): JSX.Element => <nav role="listbox" aria-label="Breadcrumb dropdown" ref={dropdownRef} onMouseLeave={onMouseLeave} sx={{
  ...styles.breadcrumbDropdown(activeDropdown !== null),
  left: `${leftPosition}px`
}}>
    {activeDropdown && <>
        {activeDropdown.href ? <div sx={styles.dropdownItemActive} role="option" aria-selected="true">
            <Link href={activeDropdown.href} sx={styles.dropdownItemLink} tabIndex={0}>
              {activeDropdown.name}
            </Link>
          </div> : <div sx={styles.dropdownItemActive} role="option" aria-selected="true">
            {activeDropdown.name}
          </div>}
        {activeDropdown.siblings?.map(sibling => sibling.href && <div sx={styles.dropdownItem} key={`sibling-${activeDropdown.id}-${sibling.id}`} role="option" aria-selected="false">
                <Link href={sibling.href} sx={styles.dropdownItemLink} tabIndex={0}>
                  {sibling.name}
                </Link>
              </div>)}
      </>}
  </nav>;
export default BreadcrumbDropdown;